import React from 'react';

import { SidebarModalSectionComponent } from 'design/sidebarModal';
import { useIntlDictionary } from 'hooks/useIntlDictionary';
import { TextComponent } from 'design/text/textComponents';
import { ModalPressControlComponent } from 'design/modalPressControl';
import { MarginComponent } from 'design/margin';
import { useUserPartnerProfile } from 'hooks/useUserPartnerProfile';
import { useAccountEmail } from 'hooks/useAccountEmail';
import { ParagraphComponent } from 'design/paragraph';
import { ReactComponent as GeolocationIcon } from 'svg/geolocation.svg';
import { ReactComponent as PhoneIcon } from 'svg/phone.svg';
import { ReactComponent as MailIcon } from 'svg/mail.svg';
import { IconRowComponent } from 'design/iconRow/iconRowComponents';
import { AvatarComponent } from 'design/avatar';

type Props = {
  onEditProfile(): void;
  onEditPassword(): void;
};

export const PartnerAccountManagerSummary = (props: Props) => {
  const { onEditPassword: editPassowrd, onEditProfile: editProfile } = props;

  const {
    partnerAccountManager: { summaryScreen: ownDictionary },
  } = useIntlDictionary();

  const accountEmail = useAccountEmail();

  const partnerProfile = useUserPartnerProfile();

  return (
    <>
      <SidebarModalSectionComponent
        content={
          <>
            {partnerProfile.avatarURL && (
              <>
                <AvatarComponent url={partnerProfile.avatarURL} alt="avatar" />
                <MarginComponent top={32} />
              </>
            )}
            <TextComponent size="mp" weight="medium">
              {ownDictionary.summaryTitleValue(partnerProfile)}
            </TextComponent>
            <MarginComponent top={28} />
            <ParagraphComponent>{partnerProfile.details}</ParagraphComponent>
            <MarginComponent top={27} />
            {partnerProfile.country && partnerProfile.city && (
              <>
                <IconRowComponent
                  icon={<GeolocationIcon />}
                  text={
                    <TextComponent>
                      {ownDictionary.locatonValue(
                        partnerProfile.country,
                        partnerProfile.city
                      )}
                    </TextComponent>
                  }
                />
                <MarginComponent top={16} />
              </>
            )}
            <IconRowComponent
              icon={<MailIcon />}
              text={<TextComponent>{accountEmail}</TextComponent>}
            />
            <MarginComponent top={16} />
            <IconRowComponent
              icon={<PhoneIcon />}
              text={<TextComponent>{partnerProfile.phone}</TextComponent>}
            />
          </>
        }
        actions={
          <>
            <ModalPressControlComponent
              type="button"
              theme="secondary"
              onPress={editProfile}
            >
              {ownDictionary.editProfileActionText}
            </ModalPressControlComponent>
            <MarginComponent top={20} />
            <ModalPressControlComponent
              type="button"
              theme="secondary"
              onPress={editPassowrd}
            >
              {ownDictionary.editPasswordActionText}
            </ModalPressControlComponent>
          </>
        }
      />
    </>
  );
};
